import m from 'mithril';
import MessageProvider from '../../../MessageProvider';
import { SvgIcon, Dialog } from '../MaterialDesignComponents';
import { getValueByLang } from "../../../Utils";
import { TemporaryRoomTypeSelection} from '../../../Models';

interface Attrs {
    roomTypeSelection: TemporaryRoomTypeSelection,
    messageProvider: MessageProvider,
    onSelectionRemoved: (roomTypeSelection: TemporaryRoomTypeSelection) => void
}

export default function SelectedRoomListItemComponent(): m.Component<Attrs> {   
    let showingDialog = false;
    return {
        view(vnode){ 
            const { roomTypeSelection, messageProvider, onSelectionRemoved} = vnode.attrs;
            const roomType = roomTypeSelection.roomType;
            const roomTypeName = getValueByLang(roomType.name, messageProvider.getCurrentLang());
            const maxOccupancy = roomType.standardOccupancy + roomTypeSelection.numberOfExtraBeds;  

            return m("div", [
                m("div.row no-gutters p-1", [
                    m("div.col-4",
                        m("img.card-img w-100 h-100 rounded-16", {src: roomType.featuredPhotoUrl})
                    ),
                    m("div.col-8 pl-2", [
                        m("div.d-flex align-items-center", [
                            m("div.flex-grow-1", { class: "ml-2" }, 
                                m("strong", { class: "room-name-color" }, getValueByLang(roomType.name, messageProvider.getCurrentLang()))
                            ),
                            m("div", {
                                onclick: function (event:Event) {
                                    event.preventDefault();
                                    showingDialog = true;
                                }
                            }, [
                                m("button.btn btn-light btn-sm text-danger", m("small", messageProvider.get("delete")))
                            ])                        
                        ]),
                        m("div", { class: "ml-2 mb-2" },      
                            m("div.row py-1", [
                                m("div.col col-auto",
                                    m("small", messageProvider.get("stay") + " - ")
                                ),
                                m("div.col pl-0", [
                                    m("small", messageProvider.interpolate("number_of_adults", {count:maxOccupancy})),

                                    (roomType.maxChildAge > 0)? 
                                    [
                                        m("small", ((messageProvider.getCurrentLang() == "en")?", ": "၊ ") +  messageProvider.interpolate("number_of_child", {count: 1})),
                                    ]:null
                                ])
                            ]),

                            (roomTypeSelection.numberOfExtraBeds > 0)? 
                            m("div.pb-1", 
                                m("small", {}, messageProvider.get("extra_bed") + " - " + roomTypeSelection.numberOfExtraBeds + " " + messageProvider.get("included"))
                            ):null,
                    
                            m("div.row", [
                                m("div.col col-auto", [
                                    m("small", messageProvider.interpolate("for_nights", {nights:roomTypeSelection.numberOfNights}) + " - ")
                                ]),
                                m("div.col pl-0", [
                                    m("small", { class: "font-weight-bold" }, new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(roomTypeSelection.getSubtotalAmount()) + " MMK"),
                                    (roomTypeSelection.getDiscountAmount() > 0 && roomTypeSelection.numberOfExtraBeds > 0)? 
                                    m("small.text-muted", " ( " + messageProvider.get("discount_applied_and_extra_bed_included") + " )"): null,
                                    
                                    (roomTypeSelection.getDiscountAmount() > 0 && roomTypeSelection.numberOfExtraBeds == 0)? 
                                    m("small.text-muted", " ( " + messageProvider.get("discount_applied") + " )"):null,

                                    (roomTypeSelection.getDiscountAmount() == 0 && roomTypeSelection.numberOfExtraBeds > 0)?
                                    m("small.text-muted", " ( " + messageProvider.get("extra_bed_included") + " )"):null
                                    
                                ]) 
                            ]),
                        )
                    ])
                ]),
                m(Dialog, {
                    isOpen: showingDialog,
                    onClose: () => {
                        showingDialog = false;
                    },
                    actionItems: [
                        {
                            label: "Cancel",
                            onclick: () => {
                                showingDialog = false;
                            }
                        },
                        {
                            label: "Ok",
                            onclick: () => {
                                onSelectionRemoved(roomTypeSelection);
                                showingDialog = false;
                            }
                        }
                    ]
                }, [
                    m("div.text-center",
                        m(SvgIcon, {
                            iconType: "warning",
                            colorScheme: "accent",
                            sizeScheme: "largest"
                        })
                    ),
                    m("div", { class: "mb-1" }, roomTypeName + " " + messageProvider.get("delete_room"))
                ])
            ])
        }
    }
}